<template>
  <div class="d-flex w-full align-center">
    <Bloco
      :height="`${altura + 20}px`"
      width="250px"
      class="bg-white mt-n19px"
    >
      <slot name="footer.bloco.esquerdo" />
    </Bloco>

    <v-spacer />

    <div class="mt-n19px bg-white" style="padding-left: 2.1vh">
      <Bloco
        :height="`${altura + 20}px`"
        width="192px"
        class="bg-white d-flex align-center"
      >
        <div class="w-full text-right pr-4 font-12">
          Total itens: {{countItems}}
        </div>
      </Bloco>
    </div>
  </div>
</template>

<script>
import Bloco from "./Bloco";

export default {
  name: "Rodape",
  components: {
    Bloco
  },
  props: {
    countItems: Number
  },
  data: () => ({
    altura: 35
  })
}
</script>

<style scoped>
.mt-n19px {
  margin-top: -3vh;
}
</style>
